// Delegation also covers header sections replaced by the theme editor.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-df-menu-more]');
  if (!button) return;
  const list = document.getElementById(button.getAttribute('aria-controls'));
  if (!list) return;
  const expanded = button.getAttribute('aria-expanded') !== 'true';
  button.setAttribute('aria-expanded', String(expanded));
  list.dataset.expanded = String(expanded);
});
